import { render, staticRenderFns } from "./UpdatedSavedDashboard.vue?vue&type=template&id=6f9d39f0&scoped=true"
import script from "./UpdatedSavedDashboard.vue?vue&type=script&lang=js"
export * from "./UpdatedSavedDashboard.vue?vue&type=script&lang=js"
import style0 from "./UpdatedSavedDashboard.vue?vue&type=style&index=0&id=6f9d39f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d39f0",
  null
  
)

export default component.exports